import { useEffect } from 'react';


export default function NewChatConfirmModal({
  isNewChatConfirmOpen,
  setIsNewChatConfirmOpen,
  handleConfirmNewChat,
}) {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        setIsNewChatConfirmOpen(false);
      }
    };
    if (isNewChatConfirmOpen) {
      window.addEventListener('keydown', handleKeyDown);
    }
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isNewChatConfirmOpen, setIsNewChatConfirmOpen]);

  if (!isNewChatConfirmOpen) return null;

  return (
    <div className="fixed inset-0 z-[170] bg-black/80 backdrop-blur-sm flex items-center justify-center p-4" onClick={(e) => { if (e.target === e.currentTarget) setIsNewChatConfirmOpen(false); }}>
      <div className="w-full max-w-sm bg-gray-900 border border-gray-800 rounded-2xl shadow-2xl p-6 space-y-6">
        <div className="flex flex-col items-center text-center space-y-2">
          <div className="w-12 h-12 bg-blue-600/20 rounded-full flex items-center justify-center mb-2">
            <svg className="w-6 h-6 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
            </svg>
          </div>
          <h3 className="text-lg font-bold text-white">新規ルームを作成しますか？</h3>
          <p className="text-sm text-gray-400 leading-relaxed">
            現在の会話は履歴に保存され、<br />新しいトピックで議論を開始できます。
          </p>
        </div>

        <div className="flex gap-3 pt-2">
          <button
            type="button"
            onClick={() => setIsNewChatConfirmOpen(false)}
            className="flex-1 bg-gray-800 hover:bg-gray-700 text-gray-300 py-3 rounded-xl text-sm font-bold transition-colors"
          >
            戻る
          </button>
          <button
            onClick={handleConfirmNewChat}
            className="flex-1 bg-blue-600 hover:bg-blue-500 text-white py-3 rounded-xl text-sm font-bold shadow-lg shadow-blue-600/20 transition-all active:scale-95"
          >
            開始する
          </button>
        </div>
      </div>
    </div>
  );
}
